<template>
  <div class="container position-sticky h-100 fs-7">
    <span v-show='loading' class="position-absolute top-50 start-50 translate-middle">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </span>
    <div class="row">
        <div class="col-6">
            <div class="card mb-3 h-100" >
                <div class="card-header fs-5">Inventory Query: {{InvQuery.StockCode}}</div>
             
                <div class="card-body pt-2">
                    <div class="row pb-1">
                        <div class="col-4">
                            Description:
                        </div>
                        <div class="col-8">
                            {{InvQuery.Description}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            Long Desc:
                        </div>
                        <div class="col-8">
                            {{InvQuery.LongDesc}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            UOM:
                        </div>
                        <div class="col-8">
                            {{InvQuery.StockUom}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            Part Category:
                        </div>
                        <div class="col-8">
                            {{InvQuery.PartCategory}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            “On Hold” status:
                        </div>
                        <div class="col-8">
                             <span > {{InvQuery.StockOnHold}} {{InvQuery.StockOnHoldReason}}</span>
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            Warehouse To Use:
                        </div>
                        <div class="col-8">
                            {{InvQuery.WarehouseToUse}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            JCP:
                        </div>
                        <div class="col-8">
                            JCP
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            ECN:
                        </div>
                        <div class="col-8">
                            {{InvQuery.DrawOfficeNum}} &nbsp; &nbsp; Release: {{InvQuery.Release}} Revision: {{InvQuery.Version}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card mb-3 h-100" >
                <div class="card-header fs-5">Bought Out Part: {{InvQuery.StockCode}}</div>
                <div class="card-body pt-2">
                    <div class="row pb-1">
                        <div class="col-4">
                            Supplier Code:
                        </div>
                        <div class="col-8">
                            {{InvQuery.Supplier}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            Supplier Name:
                        </div>
                        <div class="col-8">
                            {{InvQuery.SupplierName}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            Buyer Name:
                        </div>
                        <div class="col-8">
                            {{InvQuery.Bname}}
                        </div>
                    </div>
                    <div class="row pb-1">
                        <div class="col-4">
                            Material Cost:
                        </div>
                        <div class="col-8">
                            {{qtyFormat(InvQuery.MaterialCost)}}
                        </div>
                    </div> 
                </div>
                <div class="card-footer"> 
                    <router-link :to="whereUsedQuery" class="btn btn-primary" target="_blank">Where Used Query</router-link>
                </div>
            </div>
        </div>
    </div>
     
    <WarehouseSOHVue :WarehouseSOH="WarehouseSOH"></WarehouseSOHVue>
     
  </div>
</template>

<script>
import WarehouseSOHVue from './WarehouseSOH.vue';
import {BaseDataService} from '../../../services/BaseData.service';
export default {
    props: { StockCode: String},
    components:{
        WarehouseSOHVue
    },
    computed: {
    bomSelectStockCode() {
      return this.$store.state.bomStockCode.bomSelectStockCode;
    },
    whereUsedQuery(){
        return "/flatbom/"+this.$store.state.bomStockCode.bomSelectStockCode+"/0";
    } 
  },
  data: () => ({
        loading:true,
        InvQuery:{},
        WarehouseSOH:[]

    }),
    watch:{
    bomSelectStockCode(newValue){
      this.checkSendServer(newValue);
    }
  },
  mounted(){
    if(this.StockCode){
        this.checkSendServer(this.StockCode)
    }
  },
  methods: { 
    checkSendServer(newValue){
        if(newValue!=""){
            this.loading= true;
            BaseDataService.getInvQuery(newValue).then(x=>{
                this.loading = false;
                this.InvQuery= x.data;
            });
            BaseDataService.getSOH(newValue).then(x=>{
                this.loading = false;
                this.WarehouseSOH= x.data;
            });

        }
    },
    qtyFormat(Num){
        return Number(Num).toFixed(3)
    }
  }
}   
</script>

<style>
.fs-7{
    font-size: 0.8rem !important;
}
.pb-1{
    padding-bottom: 5px;
}
</style>